import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {CompanyAct, CompanyActSearchParams} from '@accounting/_common/models/company-act.models';

export const CheckState = createAction(
    '[CompanyActs] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: CompanyAct[] } }>()
);

export const CheckStateSuccess = createAction(
    '[CompanyActs] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: CompanyAct[] } }>()
);

export const LoadList = createAction(
    '[CompanyActs] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[CompanyActs] Load List Success',
    props<{ payload: { items: CompanyAct[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[CompanyActs] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[CompanyActs] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[CompanyActs] Set Filter',
    props<{ payload: CompanyActSearchParams }>()
);

export const SetLoading = createAction(
    '[CompanyActs] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[CompanyActs] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[CompanyActs] Update Item Success',
    props<{ payload: CompanyAct }>()
);

export const DeleteItem = createAction(
    '[CompanyActs] Delete Item',
    props<{ payload: CompanyAct }>()
);

export const DeleteItemSuccess = createAction(
    '[CompanyActs] Delete Item Success',
    props<{ payload: CompanyAct }>()
);

export const DeleteItemFailure = createAction(
    '[CompanyActs] Delete Item Failure',
    props<{ payload: CompanyAct }>()
);

export const SetInitialState = createAction(
    '[CompanyActs] Set Initial State'
);
